<template>
  <wo-region v-if="company">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.company.editTitle'" />
    </wo-layout>
    <company-edit :value="company" @input="confirm" @cancel="confirm" />
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { ADMIN_COMPANY } from '@/routes/admin'

import { companyRepository } from '@/repository/company'

import CompanyEdit from '@/components/admin/CompanyEdit'

export default {
  components: { CompanyEdit },
  props: {
    companyId: [Number, String]
  },
  computed: mapState({
    company: state => state.company.company
  }),
  created () {
    this.loadCompany()
  },
  methods: {
    loadCompany () {
      this.$store.dispatch(companyRepository.find, { id: this.companyId })
    },
    confirm () {
      this.$router.push({ name: ADMIN_COMPANY })
    }
  }
}
</script>
